import TrailConditionsAlertDisplayed from '@alltrails/amplitude/enums/TrailConditionsAlertDisplayed';
import TrailConditionsScreen from '@alltrails/amplitude/enums/TrailConditionsScreen';
import TrailDetailsDaysInAdvance from '@alltrails/amplitude/enums/TrailDetailsDaysInAdvance';
import TrailDetailsPageTerrainCondition from '@alltrails/amplitude/enums/TrailDetailsPageTerrainCondition';
import TrailConditionAlertType from '@alltrails/conditions/types/TrailConditionAlertType';
import TrailConditionKey from '@alltrails/conditions/types/TrailConditionKey';
import { ConditionStyleId } from '@alltrails/maps/types/Styles';

export const getTrailConditionsAlertDisplayed = (alertType?: TrailConditionAlertType): TrailConditionsAlertDisplayed | undefined => {
  switch (alertType) {
    case 'airQualityExtremelyPoor':
    case 'airQualityPoor':
    case 'airQualityVeryPoor':
      return 'poor air quality';
    case 'heatAdvisory':
    case 'heatExcessiveWarning':
    case 'heatExcessiveWatch':
      return 'excessive heat';
    case 'rainExtreme':
    case 'rainSevere':
      return 'heavy rainfall';
    case 'snowExtreme':
      return 'heavy snowfall';
    case 'thunderstormsSevere':
      return 'severe thunderstorms';
    case 'windExtreme':
    case 'windHigh':
    case 'windSevere':
      return 'high winds';
    case 'mosquitoHigh':
      return 'high mosquito activity';
    case 'mosquitoModerate':
      return 'some mosquito activity';
    case 'mosquitoVeryHigh':
      return 'peak mosquito activity';
    default:
      return undefined;
  }
};

export const getTrailConditionsScreen = (condition: ConditionStyleId): TrailConditionsScreen | undefined => {
  switch (condition) {
    case 'groundConditions':
      return 'muddy';
    case 'precipitation':
      return 'rain';
    case 'snowDepth':
      return 'snow';
    case 'temperature':
      return 'warmest';
    default:
      return undefined;
  }
};

export const getTrailDetailsDaysInAdvance = (daysAhead: number): TrailDetailsDaysInAdvance | undefined => {
  switch (daysAhead) {
    case 0:
      return 'current day';
    case 1:
      return 'days after 1';
    case 2:
      return 'days after 2';
    case 3:
      return 'days after 3';
    case 4:
      return 'days after 4';
    case 5:
      return 'days after 5';
    case 6:
      return 'days after 6';
    case 7:
      return 'days after 7';
    default:
      return undefined;
  }
};

export const getTrailDetailsPageTerrainCondition = (trailConditionKey: TrailConditionKey): TrailDetailsPageTerrainCondition => {
  switch (trailConditionKey) {
    case 'dry':
      return 'dry';
    case 'dry_dusty':
      return 'dry and dusty';
    case 'icy':
      return 'icy';
    case 'muddy':
      return 'muddy';
    case 'muddy_icy':
      return 'muddy and icy';
    case 'snowy':
      return 'snowy';
    case 'snowy_icy':
      return 'snowy and icy';
    default:
      return 'unknown';
  }
};
